var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8510_8338)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8510_8338",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.7571 0.261719C78.2929 0.261719 99.8857 22.5974 99.8857 50.1474C99.8857 77.6974 77.6071 99.4903 51.0214 99.4903C41.5857 99.4903 37.0143 98.1617 29.65 92.9474C29.1429 92.5903 28.45 92.6831 28.0214 93.1403C22.3571 99.1831 7.85 103.426 7.18571 95.176C7.18571 80.7903 0 71.4474 0 49.876C0 21.5546 23.2214 0.261719 50.7571 0.261719ZM51.5286 24.8117C38.4643 24.126 28.2643 33.1974 26.0143 47.3831C24.15 59.1332 27.45 73.4546 30.2786 74.176C31.4786 74.4832 34.3571 72.276 36.4571 70.2974C36.85 69.926 37.45 69.8617 37.9071 70.1474C41.1786 72.1474 44.8786 73.6474 48.9571 73.8617C62.3714 74.5617 74.2571 64.0617 74.9643 50.6474C75.6643 37.2331 64.9429 25.5046 51.5286 24.8046V24.8117Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8510_8338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6996 50.0808L-12.4076 84.5022C-13.4076 82.6951 -14.329 80.8451 -15.1719 78.9594L49.6924 50.0808H49.6996Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6975 50.0808L-15.1739 78.9594C-16.0167 77.0737 -16.7739 75.1522 -17.4453 73.1951L49.6904 50.0808H49.6975Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6969 50.0808L-17.446 73.1951C-18.1174 71.2451 -18.7031 69.2594 -19.2031 67.2594L49.6969 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6982 50.0808L-19.2018 67.2594C-19.7018 65.2522 -20.1161 63.2308 -20.4375 61.188L49.6911 50.0808H49.6982Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6997 50.0808L-20.4289 61.188C-20.7503 59.1451 -20.986 57.0951 -21.1289 55.0308L49.7068 50.0808H49.6997Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6979 50.0821L-21.1379 55.0321C-21.2807 52.9678 -21.3379 50.9035 -21.3021 48.8392L49.6907 50.0821H49.6979Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.696 50.082L-21.2969 48.8392C-21.2612 46.7749 -21.1326 44.7106 -20.9183 42.6534L49.696 50.0749V50.082Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6963 50.0817L-20.918 42.6603C-20.7037 40.6032 -20.3965 38.5603 -20.0037 36.5317L49.6963 50.0817Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6993 50.0819L-20.0078 36.5319C-19.615 34.5034 -19.1292 32.4962 -18.565 30.5105L49.6922 50.0819H49.6993Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6986 50.0801L-18.5586 30.5086C-17.9872 28.5229 -17.33 26.5658 -16.5943 24.6372L49.6986 50.0872V50.0801Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6991 50.0822L-16.5938 24.6322C-15.8509 22.7036 -15.0295 20.8108 -14.1223 18.9536L49.6991 50.0822Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6964 50.0814L-14.125 18.9529C-13.2179 17.0957 -12.2321 15.2814 -11.1679 13.51L49.6964 50.0814Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6963 50.0811L-11.168 13.5096C-10.1037 11.7382 -8.96083 10.0168 -7.74654 8.34534L49.6963 50.0811Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6961 50.0818L-7.75391 8.34609C-6.53962 6.67466 -5.25391 5.06038 -3.89676 3.49609L49.6889 50.0818H49.6961Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6983 50.0825L-3.89453 3.49676C-2.53739 1.93962 -1.11596 0.43962 0.369754 -0.996094L49.6912 50.0825H49.6983Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6997 50.0824L0.371094 -0.996129C1.85681 -2.43184 3.40681 -3.80327 5.01395 -5.10327L49.6997 50.0824Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6974 50.0824L5.01172 -5.10335C6.61886 -6.40335 8.276 -7.63192 9.99029 -8.78906L49.6974 50.0752V50.0824Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6993 50.0814L9.99219 -8.79004C11.7065 -9.94718 13.4636 -11.0258 15.2708 -12.0258L49.6922 50.0814H49.6993Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6981 50.0807L15.2695 -12.0265C17.0767 -13.0265 18.9267 -13.9479 20.8124 -14.7908L49.691 50.0735H49.6981V50.0807Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6982 50.0808L20.8125 -14.7906C22.6982 -15.6334 24.6196 -16.3906 26.5768 -17.062L49.6911 50.0737H49.6982V50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6996 50.0814L26.5781 -17.0543C28.5281 -17.7257 30.5138 -18.3114 32.521 -18.8114L49.6996 50.0886V50.0814Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6981 50.0798L32.5195 -18.8202C34.5267 -19.3202 36.5481 -19.7345 38.591 -20.0559L49.6981 50.0798Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.697 50.0808L38.5898 -20.0478C40.6327 -20.3692 42.6827 -20.6049 44.747 -20.7478L49.697 50.0879V50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6961 50.0812L44.7461 -20.7546C46.8104 -20.8974 48.8747 -20.9546 50.939 -20.9188L49.6961 50.074V50.0812Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0804L50.9421 -20.9125C53.0064 -20.8768 55.0706 -20.7482 57.1278 -20.5339L49.7064 50.0804H49.6992Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0813L57.1206 -20.533C59.1778 -20.3187 61.2206 -20.0115 63.2492 -19.6187L49.6992 50.0813Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0822L63.2492 -19.6178C65.2778 -19.2249 67.2849 -18.7392 69.2706 -18.1749L49.6992 50.0822Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6986 50.0818L69.27 -18.1753C71.2557 -17.6039 73.2128 -16.9467 75.1414 -16.211L49.6914 50.0818H49.6986Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6986 50.0819L75.1414 -16.2109C77.07 -15.4681 78.9628 -14.6467 80.82 -13.7395L49.6914 50.0819H49.6986Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0825L80.8278 -13.7389C82.6849 -12.8317 84.4992 -11.846 86.2706 -10.7817L49.6992 50.0825Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0802L86.2706 -10.7841C88.0421 -9.71977 89.7635 -8.57691 91.4349 -7.36263L49.6992 50.0802Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0823L91.4349 -7.3606C93.1064 -6.14631 94.7206 -4.8606 96.2849 -3.50345L49.6992 50.0823Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0799L96.2849 -3.51294C97.8421 -2.1558 99.3421 -0.734368 100.778 0.751347L49.6992 50.0728V50.0799Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0819L100.778 0.753296C102.214 2.23901 103.585 3.78901 104.885 5.39615L49.6992 50.0819Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0818L104.878 5.39612C106.178 7.00326 107.406 8.6604 108.564 10.3747L49.6992 50.0818Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6986 50.0809L108.563 10.3738C109.72 12.0881 110.799 13.8452 111.799 15.6523L49.6914 50.0738H49.6986V50.0809Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0799L111.806 15.6584C112.806 17.4656 113.728 19.3156 114.571 21.2013L49.7064 50.0799H49.6992Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0811L114.563 21.2025C115.406 23.0882 116.163 25.0097 116.835 26.9668L49.6992 50.0811Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6986 50.0813L116.834 26.967C117.506 28.917 118.091 30.9028 118.591 32.9099L49.6914 50.0885L49.6986 50.0813Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0803L118.599 32.9017C119.099 34.9089 119.514 36.9303 119.835 38.9732L49.6992 50.0803Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6986 50.0803L119.827 38.9731C120.149 41.016 120.384 43.066 120.527 45.1303L49.6914 50.0803H49.6986Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0811L120.535 45.1311C120.678 47.1954 120.735 49.2597 120.699 51.324L49.7064 50.0811H49.6992Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L120.692 51.3237C120.656 53.388 120.528 55.4522 120.314 57.5094L49.6992 50.088V50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L120.314 57.5022C120.099 59.5594 119.792 61.6022 119.399 63.6308L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L119.399 63.6308C119.006 65.6594 118.521 67.6665 117.956 69.6522L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0825L117.956 69.6539C117.385 71.6396 116.728 73.5967 115.992 75.5253L49.6992 50.0753V50.0825Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L115.992 75.5308C115.249 77.4594 114.428 79.3522 113.521 81.2094L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L113.521 81.2094C112.613 83.0665 111.628 84.8808 110.563 86.6522L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L110.563 86.6522C109.499 88.4237 108.356 90.1451 107.142 91.8165L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L107.142 91.8165C105.928 93.4879 104.642 95.1022 103.285 96.6665L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L103.285 96.6665C101.928 98.2237 100.506 99.7237 99.0206 101.159L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L99.0207 101.159C97.5349 102.595 95.9849 103.967 94.3849 105.267L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L94.3849 105.267C92.7778 106.567 91.1206 107.795 89.4064 108.952L49.6992 50.088V50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0825L89.4064 108.947C87.6921 110.104 85.9349 111.182 84.1278 112.182L49.7064 50.0753H49.6992V50.0825Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L84.1206 112.188C82.3135 113.188 80.4635 114.109 78.5778 114.952L49.6992 50.088V50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L78.5778 114.945C76.6921 115.788 74.7706 116.545 72.8135 117.217L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6986 50.0825L72.8128 117.218C70.8557 117.89 68.8771 118.475 66.87 118.975L49.6914 50.0753H49.6986V50.0825Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L66.8778 118.981C64.8706 119.481 62.8492 119.895 60.8064 120.217L49.6992 50.088V50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L60.8064 120.217C58.7635 120.538 56.7135 120.774 54.6492 120.917L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.696 50.0808L54.646 120.917C52.5817 121.059 50.5174 121.117 48.4531 121.081L49.696 50.088V50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6981 50.0808L48.4552 121.074C46.391 121.038 44.3267 120.909 42.2695 120.695L49.691 50.0808H49.6981Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6984 50.0808L42.277 120.695C40.2199 120.481 38.177 120.174 36.1484 119.781L49.6984 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6964 50.0808L36.1464 119.781C34.1179 119.388 32.1107 118.902 30.125 118.338L49.6964 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6968 50.0808L30.1253 118.338C28.1396 117.767 26.1825 117.109 24.2539 116.374L49.7039 50.0808H49.6968Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6989 50.0808L24.2489 116.374C22.3203 115.631 20.4275 114.809 18.5703 113.902L49.6989 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6964 50.0808L18.5679 113.902C16.7107 112.995 14.8964 112.009 13.125 110.945L49.6964 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6967 50.0808L13.1252 110.945C11.3538 109.881 9.63237 108.738 7.96094 107.524L49.6967 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6983 50.0808L7.95547 107.524C6.28404 106.309 4.66975 105.024 3.10547 103.667L49.6912 50.0808H49.6983Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6997 50.0808L3.11395 103.667C1.55681 102.309 0.0568079 100.888 -1.37891 99.4022L49.6997 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6974 50.0808L-1.38114 99.4022C-2.81685 97.9165 -4.18828 96.3665 -5.48828 94.7665L49.6974 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6996 50.0808L-5.48616 94.7665C-6.78616 93.1594 -8.01473 91.5022 -9.17188 89.7879L49.6924 50.0808H49.6996Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.697 50.0808L-9.17444 89.788C-10.3316 88.0737 -11.4102 86.3094 -12.4102 84.5022L49.697 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8510_8338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6996 50.0808L-12.4076 84.5022C-13.4076 82.6951 -14.329 80.8451 -15.1719 78.9594L49.6924 50.0808H49.6996Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6975 50.0808L-15.1739 78.9594C-16.0167 77.0737 -16.7739 75.1522 -17.4453 73.1951L49.6904 50.0808H49.6975Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6969 50.0808L-17.446 73.1951C-18.1174 71.2451 -18.7031 69.2594 -19.2031 67.2594L49.6969 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6982 50.0808L-19.2018 67.2594C-19.7018 65.2522 -20.1161 63.2308 -20.4375 61.188L49.6911 50.0808H49.6982Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6997 50.0808L-20.4289 61.188C-20.7503 59.1451 -20.986 57.0951 -21.1289 55.0308L49.7068 50.0808H49.6997Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6979 50.0821L-21.1379 55.0321C-21.2807 52.9678 -21.3379 50.9035 -21.3021 48.8392L49.6907 50.0821H49.6979Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.696 50.082L-21.2969 48.8392C-21.2612 46.7749 -21.1326 44.7106 -20.9183 42.6534L49.696 50.0749V50.082Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6963 50.0817L-20.918 42.6603C-20.7037 40.6032 -20.3965 38.5603 -20.0037 36.5317L49.6963 50.0817Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6993 50.0819L-20.0078 36.5319C-19.615 34.5034 -19.1292 32.4962 -18.565 30.5105L49.6922 50.0819H49.6993Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6986 50.0801L-18.5586 30.5086C-17.9872 28.5229 -17.33 26.5658 -16.5943 24.6372L49.6986 50.0872V50.0801Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6991 50.0822L-16.5938 24.6322C-15.8509 22.7036 -15.0295 20.8108 -14.1223 18.9536L49.6991 50.0822Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6964 50.0814L-14.125 18.9529C-13.2179 17.0957 -12.2321 15.2814 -11.1679 13.51L49.6964 50.0814Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6963 50.0811L-11.168 13.5096C-10.1037 11.7382 -8.96083 10.0168 -7.74654 8.34534L49.6963 50.0811Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6961 50.0818L-7.75391 8.34609C-6.53962 6.67466 -5.25391 5.06038 -3.89676 3.49609L49.6889 50.0818H49.6961Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6983 50.0825L-3.89453 3.49676C-2.53739 1.93962 -1.11596 0.43962 0.369754 -0.996094L49.6912 50.0825H49.6983Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6997 50.0824L0.371094 -0.996129C1.85681 -2.43184 3.40681 -3.80327 5.01395 -5.10327L49.6997 50.0824Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6974 50.0824L5.01172 -5.10335C6.61886 -6.40335 8.276 -7.63192 9.99029 -8.78906L49.6974 50.0752V50.0824Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6993 50.0814L9.99219 -8.79004C11.7065 -9.94718 13.4636 -11.0258 15.2708 -12.0258L49.6922 50.0814H49.6993Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6981 50.0807L15.2695 -12.0265C17.0767 -13.0265 18.9267 -13.9479 20.8124 -14.7908L49.691 50.0735H49.6981V50.0807Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6982 50.0808L20.8125 -14.7906C22.6982 -15.6334 24.6196 -16.3906 26.5768 -17.062L49.6911 50.0737H49.6982V50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6996 50.0814L26.5781 -17.0543C28.5281 -17.7257 30.5138 -18.3114 32.521 -18.8114L49.6996 50.0886V50.0814Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6981 50.0798L32.5195 -18.8202C34.5267 -19.3202 36.5481 -19.7345 38.591 -20.0559L49.6981 50.0798Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.697 50.0808L38.5898 -20.0478C40.6327 -20.3692 42.6827 -20.6049 44.747 -20.7478L49.697 50.0879V50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6961 50.0812L44.7461 -20.7546C46.8104 -20.8974 48.8747 -20.9546 50.939 -20.9188L49.6961 50.074V50.0812Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0804L50.9421 -20.9125C53.0064 -20.8768 55.0706 -20.7482 57.1278 -20.5339L49.7064 50.0804H49.6992Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0813L57.1206 -20.533C59.1778 -20.3187 61.2206 -20.0115 63.2492 -19.6187L49.6992 50.0813Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0822L63.2492 -19.6178C65.2778 -19.2249 67.2849 -18.7392 69.2706 -18.1749L49.6992 50.0822Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6986 50.0818L69.27 -18.1753C71.2557 -17.6039 73.2128 -16.9467 75.1414 -16.211L49.6914 50.0818H49.6986Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6986 50.0819L75.1414 -16.2109C77.07 -15.4681 78.9628 -14.6467 80.82 -13.7395L49.6914 50.0819H49.6986Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0825L80.8278 -13.7389C82.6849 -12.8317 84.4992 -11.846 86.2706 -10.7817L49.6992 50.0825Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0802L86.2706 -10.7841C88.0421 -9.71977 89.7635 -8.57691 91.4349 -7.36263L49.6992 50.0802Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0823L91.4349 -7.3606C93.1064 -6.14631 94.7206 -4.8606 96.2849 -3.50345L49.6992 50.0823Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0799L96.2849 -3.51294C97.8421 -2.1558 99.3421 -0.734368 100.778 0.751347L49.6992 50.0728V50.0799Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0819L100.778 0.753296C102.214 2.23901 103.585 3.78901 104.885 5.39615L49.6992 50.0819Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0818L104.878 5.39612C106.178 7.00326 107.406 8.6604 108.564 10.3747L49.6992 50.0818Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6986 50.0809L108.563 10.3738C109.72 12.0881 110.799 13.8452 111.799 15.6523L49.6914 50.0738H49.6986V50.0809Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0799L111.806 15.6584C112.806 17.4656 113.728 19.3156 114.571 21.2013L49.7064 50.0799H49.6992Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0811L114.563 21.2025C115.406 23.0882 116.163 25.0097 116.835 26.9668L49.6992 50.0811Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6986 50.0813L116.834 26.967C117.506 28.917 118.091 30.9028 118.591 32.9099L49.6914 50.0885L49.6986 50.0813Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0803L118.599 32.9017C119.099 34.9089 119.514 36.9303 119.835 38.9732L49.6992 50.0803Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6986 50.0803L119.827 38.9731C120.149 41.016 120.384 43.066 120.527 45.1303L49.6914 50.0803H49.6986Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0811L120.535 45.1311C120.678 47.1954 120.735 49.2597 120.699 51.324L49.7064 50.0811H49.6992Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L120.692 51.3237C120.656 53.388 120.528 55.4522 120.314 57.5094L49.6992 50.088V50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L120.314 57.5022C120.099 59.5594 119.792 61.6022 119.399 63.6308L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L119.399 63.6308C119.006 65.6594 118.521 67.6665 117.956 69.6522L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0825L117.956 69.6539C117.385 71.6396 116.728 73.5967 115.992 75.5253L49.6992 50.0753V50.0825Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L115.992 75.5308C115.249 77.4594 114.428 79.3522 113.521 81.2094L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L113.521 81.2094C112.613 83.0665 111.628 84.8808 110.563 86.6522L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L110.563 86.6522C109.499 88.4237 108.356 90.1451 107.142 91.8165L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L107.142 91.8165C105.928 93.4879 104.642 95.1022 103.285 96.6665L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L103.285 96.6665C101.928 98.2237 100.506 99.7237 99.0206 101.159L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L99.0207 101.159C97.5349 102.595 95.9849 103.967 94.3849 105.267L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L94.3849 105.267C92.7778 106.567 91.1206 107.795 89.4064 108.952L49.6992 50.088V50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0825L89.4064 108.947C87.6921 110.104 85.9349 111.182 84.1278 112.182L49.7064 50.0753H49.6992V50.0825Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L84.1206 112.188C82.3135 113.188 80.4635 114.109 78.5778 114.952L49.6992 50.088V50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L78.5778 114.945C76.6921 115.788 74.7706 116.545 72.8135 117.217L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6986 50.0825L72.8128 117.218C70.8557 117.89 68.8771 118.475 66.87 118.975L49.6914 50.0753H49.6986V50.0825Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L66.8778 118.981C64.8706 119.481 62.8492 119.895 60.8064 120.217L49.6992 50.088V50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 50.0808L60.8064 120.217C58.7635 120.538 56.7135 120.774 54.6492 120.917L49.6992 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.696 50.0808L54.646 120.917C52.5817 121.059 50.5174 121.117 48.4531 121.081L49.696 50.088V50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6981 50.0808L48.4552 121.074C46.391 121.038 44.3267 120.909 42.2695 120.695L49.691 50.0808H49.6981Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6984 50.0808L42.277 120.695C40.2199 120.481 38.177 120.174 36.1484 119.781L49.6984 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6964 50.0808L36.1464 119.781C34.1179 119.388 32.1107 118.902 30.125 118.338L49.6964 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6968 50.0808L30.1253 118.338C28.1396 117.767 26.1825 117.109 24.2539 116.374L49.7039 50.0808H49.6968Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6989 50.0808L24.2489 116.374C22.3203 115.631 20.4275 114.809 18.5703 113.902L49.6989 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6964 50.0808L18.5679 113.902C16.7107 112.995 14.8964 112.009 13.125 110.945L49.6964 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6967 50.0808L13.1252 110.945C11.3538 109.881 9.63237 108.738 7.96094 107.524L49.6967 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6983 50.0808L7.95547 107.524C6.28404 106.309 4.66975 105.024 3.10547 103.667L49.6912 50.0808H49.6983Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6997 50.0808L3.11395 103.667C1.55681 102.309 0.0568079 100.888 -1.37891 99.4022L49.6997 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6974 50.0808L-1.38114 99.4022C-2.81685 97.9165 -4.18828 96.3665 -5.48828 94.7665L49.6974 50.0808Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6996 50.0808L-5.48616 94.7665C-6.78616 93.1594 -8.01473 91.5022 -9.17188 89.7879L49.6924 50.0808H49.6996Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.697 50.0808L-9.17444 89.788C-10.3316 88.0737 -11.4102 86.3094 -12.4102 84.5022L49.697 50.0808Z",
    fill: "#FFD400"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8510_8338",
    x: -38.4554,
    y: -38.0721,
    width: 176.309,
    height: 176.306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.57143,
    result: "effect1_foregroundBlur_8510_8338"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8510_8338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMax);
export default __webpack_public_path__ + "static/media/max.da00f1e8067ef4c7836e87e5ee361e05.svg";
export { ForwardRef as ReactComponent };